import EventEmitter from 'eventemitter3'

export const appNotificationEvent = new EventEmitter()

export function onAppNotificationListener(payload) {
    appNotificationEvent.emit('RELOAD_NOTIFICATIONS', payload)
}

export function removeAppNotificationListener() {
    appNotificationEvent.removeListener('RELOAD_NOTIFICATIONS')
}
